// src/pages/actividades/components/agenda/CurrentTimeIndicator.tsx
import { useState, useEffect } from 'react';

interface Props {
  startHour: number;
  endHour: number;
  slotHeight: number;
}

function getNow() {
  const d = new Date();
  return { hours: d.getHours(), minutes: d.getMinutes() };
}

export function CurrentTimeIndicator({ startHour, endHour, slotHeight }: Props) {
  const [now, setNow] = useState(getNow);

  useEffect(() => {
    const interval = setInterval(() => setNow(getNow()), 60_000);
    return () => clearInterval(interval);
  }, []);

  const currentMin = now.hours * 60 + now.minutes;
  const gridStartMin = startHour * 60;
  const gridEndMin = endHour * 60;

  // Don't render if current time is outside the grid range
  if (currentMin < gridStartMin || currentMin >= gridEndMin) return null;

  const top = ((currentMin - gridStartMin) / 30) * slotHeight;
  const label = `${String(now.hours).padStart(2, '0')}:${String(now.minutes).padStart(2, '0')}`;

  return (
    <div
      className="absolute left-0 right-0 z-20 pointer-events-none"
      style={{ top: `${top}px` }}
    >
      <div className="relative flex items-center">
        <span className="absolute -left-1 -top-1.5 text-[10px] font-medium text-red-500 bg-background px-0.5 rounded">
          {label}
        </span>
        <div className="w-full border-t-2 border-red-500 ml-10" />
        <div className="absolute left-10 -top-1 h-2 w-2 rounded-full bg-red-500" />
      </div>
    </div>
  );
}
